import {configureStore} from "@reduxjs/toolkit";
import loadingSlice from "./slices/loading";
import userDataSlice from "./slices/userData";
import jobsListSlice from "./slices/jobsList";
import deptosSlice from "./slices/deptos";
import personasSlice from "./slices/personas";

export const store = configureStore({
	reducer: {
		loading:  loadingSlice,
		userData: userDataSlice,
		jobsList: jobsListSlice,
		deptosList: deptosSlice,
		personasList: personasSlice,
	}
});